import { ref } from 'vue'
import { useLoadingView } from '@/features/miiaFw/composables/useLoadingView'
import { useOverheadImageStore, type ImageUrl } from '@/stores/overheadImageUrlsStore'

/** 表示フラグ（true: 表示, false: 非表示） */
const isOpen = ref<boolean>(false)

export const useZoomOverheadImage = () => {
  const overheadImageStore = useOverheadImageStore()
  const { setLoadingView } = useLoadingView()

  /**
   * 開く
   * @param imageUrl ImageUrl
   * @returns なし
   */
  const open = async (imageUrl: ImageUrl): Promise<void> => {
    try {
      await overheadImageStore.setZoomImage(imageUrl.imageUrl)
    } finally {
      setLoadingView(false)
    }
    // コンポーネントを表示
    isOpen.value = true
  }

  /**
   * 閉じる
   * @param なし
   * @return なし
   */
  const close = (): void => {
    isOpen.value = false
  }

  /**
   * 変数群のリセット
   * @param なし
   * @returns なし
   */
  const reset = () => {
    isOpen.value = false
  }

  return {
    isOpen,
    open,
    close,
    reset
  }
}
